import React, { Component } from 'react';
import { Field } from '../Form/Form.js';

class DynamicForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {

    }
  }

  render = () => {
    if (this.props.type === "o" || this.props.type === "s") {
      return (
        <div>
          <Field id="contactName" fieldName="Contact Name" {...this.props} />
          <Field id="contactEmail" fieldName="Contact Email" {...this.props} />
          <Field id="contactNumber" fieldName="Contact Number" {...this.props} />
          <Field id="address" fieldName="Address" {...this.props} />
        </div>
      )
    } else if (this.props.type === "dc") {
      return (
        <div>
          <Field id="url" fieldName="URL" {...this.props} />
          <div className="form-group">
            <label className="col-md-4 control-label">LDAP Enabled</label>
            <div className="col-md-8">
              <label className="toggleSwitch">
                <input id="ldap" value="ldap" type="checkbox" onChange={this.props.handleChange} onClick={this.props.handleChange} checked={this.props.values.ldap} />
                <span className="toggleSwitchSlider"></span>
              </label>
            </div>
          </div>
        </div>
      ) 
    } else {
      return <div></div>
    }
  }
}

export default DynamicForm;


// WEBPACK FOOTER //
// ./src/Components/SiteManagement/DynamicForm.js